import { useCallback } from 'react'

import { useUnit } from 'effector-react'

import { Page } from '@/components/layout/page/page'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { $currentCreator } from '@/models/creators.ts'
import { openDialog } from '@/models/dialogs.ts'
import { useFunnelChecksModifier } from '@/modules/tracking/funnel/hooks/use-funnel-checks-modifier.ts'

import { FunnelChecksTableSkeleton } from './components/loaders/FunnelChecksTableSkeleton'
import { HeaderButtons } from './components/tables/FunnelTrackingHeaderOptions'
import { FunnelTrackingTable } from './components/tables/FunnelTrackingTable'
import { useFunnelChecksList } from './hooks/use-funnel-checks-list'

export const FunnelMonitoringPage = () => {
  const activeCreator = useUnit($currentCreator)
  const { data, isLoading } = useFunnelChecksList()
  const { addCheck } = useFunnelChecksModifier()

  const handleDialogOpen = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.FUNNEL_TRACKING_CREATE,
      creatorName: activeCreator?.name || '',
      onSubmit: async (body) => {
        await addCheck.mutateAsync({ body })
      },
    })
  }, [activeCreator?.name, addCheck])

  if (!activeCreator?.id || isLoading || !data) {
    return (
      <Page title="Funnel Check">
        <FunnelChecksTableSkeleton />
      </Page>
    )
  }

  return (
    <Page
      title="Funnel Check"
      headerOptions={<HeaderButtons onClickCreate={handleDialogOpen} />}
    >
      <FunnelTrackingTable />
    </Page>
  )
}
